export const ESTADO = Object.freeze({
    BORRADOR: '26',
    BORRADOR_VIGENTE: '27',
    BORRADOR_FINALIZADO: '28',
    CONFIRMADA: '29',
    ACTIVA: '30',
    FINALIZADA: '31',
    LIQUIDADA: '32',
})

export const MESSAGE_UPDATE_STATE = Object.freeze({
    LIQUIDADA: 'La comisión ya esta Liquidada',
    CONFIRMADA: 'La comisión ya esta Confirmada',
    ACTIVA: 'La comisión ya esta Activa',
    FINALIZADA: 'La comisión ya esta Finalizada',
    DEFAULT: 'Los cambios se guardaron con éxito',
})

export const COMMISSIONS_PERMITS = {
    CMS_GNC: 'CMS_GNC',
    CMS_TME: 'CMS_TME',
    CMS_VEB: 'CMS_VEB',
    CMS_VPCCH: 'CMS_VPCCH',
    CMS_EHCE: 'CMS_EHCE',
    CMS_VLC: 'CMS_VLC',
    CMS_GR: 'CMS_GR',
}

export const SALE_TYPE = {
    ZERO_KM:'0km',
    USED_CAR:'Usados',
    CONVENTIONAL:'Convencional'
}

export const ITEM_NAME = {
    BRANCH_OFFICE_ID:'branch_office_id',
    TYPE:'type', 
    INVALID_DATE:'invalidDates',
    BRAND:'brand',
    MODEL:'model',
    VERSION:'version',
    OPERATOR_SYMBOL:'operator_symbol'
}

export const FORM_TYPE = { 
    NEW:'new',
    EDIT:'edit'
}